import { feedbackConstants } from '../constants';

const initialState = {
  feedbackText: '',
  loading: false,
  openFeedback: false,
  discartFeedback: false,
};

export function feedback(state = initialState, action) {
  switch (action.type) {

    case feedbackConstants.SET_FEEDBACK_TEXT: {
      return {
        ...state,
        feedbackText: action.payload
      }
    }

    case feedbackConstants.CLEAR_FEEDBACK_TEXT: {
      return initialState;
    }

    case feedbackConstants.OPEN_FEEDBACK: {
      return {
        ...state,
        openFeedback: action.payload
      }
    }

    case feedbackConstants.DISCART_FEEDBACK: {
      return {
        ...state,
        discartFeedback: action.payload
      }
    }

    case feedbackConstants.POST_USER_FEEDBACK_REQUEST:
      return {
        loading: true
      }

    case feedbackConstants.POST_USER_FEEDBACK_SUCCESS:
      return {
        loading: false
      }

    case feedbackConstants.POST_USER_FEEDBACK_FAILURE:
      return {
        loading: false
      }

    default:
      return state;
  }
}
